/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Locked_By_Other_UserInputs */

const cs_workflow_locked_by_other_user = /** @type {(inputs: Workflow_Locked_By_Other_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow je zamknut jiným uživatelem`)
};

const en_workflow_locked_by_other_user = /** @type {(inputs: Workflow_Locked_By_Other_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow is locked by another user`)
};

/**
* | output |
* | --- |
* | "Workflow is locked by another user" |
*
* @param {Workflow_Locked_By_Other_UserInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_locked_by_other_user = /** @type {((inputs?: Workflow_Locked_By_Other_UserInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Locked_By_Other_UserInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_locked_by_other_user(inputs)
	return cs_workflow_locked_by_other_user(inputs)
});